import {
  base_colorContentBorder,
  base_colorRaisedSurface,
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_4xl,
  font_family_weight_medium,
  font_md,
} from 'ext-ui/style/typography'
import styled from 'styled-components'

export const CanvasShell = styled.section`
  min-width: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: ${spacing(4)};
  padding: ${spacing(6)};
  border: 1px solid ${base_colorContentBorder};
  border-radius: ${spacing(2)};
  background: ${base_colorRaisedSurface};
  color: ${text_colorTextPrimary};
`

export const CanvasHeading = styled.h2`
  ${font_md};
  margin: 0;
  font-family: ${font_family_weight_medium};
`

export const CanvasHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${spacing(3)};
`

export const EmptyState = styled.div`
  min-height: 240px;
  display: grid;
  place-content: center;
  gap: ${spacing(2)};
  text-align: center;
  color: ${text_colorTextSecondary};
`

export const EmptyStateHeading = styled.h3`
  margin: 0;
  ${font_md};
  font-family: ${font_family_weight_medium};
  color: ${text_colorTextPrimary};
`

export const TabList = styled.div`
  display: flex;
  gap: ${spacing(1)};
  border-bottom: 1px solid ${base_colorContentBorder};
`

export const Tab = styled.button<{ $selected: boolean }>`
  ${font_md};
  border: 0;
  border-bottom: 2px solid
    ${(props) => (props.$selected ? text_colorTextPrimary : 'transparent')};
  padding: ${spacing(2)} ${spacing(3)};
  background: transparent;
  color: ${text_colorTextPrimary};
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid ${text_colorTextPrimary};
    outline-offset: ${spacing(1)};
  }
`

export const TabPanel = styled.div`
  min-height: 0;
  flex: 1;
  overflow: auto;
`

export const Visualization = styled.figure`
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: ${spacing(3)};
`

export const VisualizationTitle = styled.h3`
  margin: 0;
  ${font_md};
  font-family: ${font_family_weight_medium};
`

export const VisualizationDescription = styled.p`
  margin: 0;
  color: ${text_colorTextSecondary};
  ${font_md};
`

export const VisualizationValue = styled.p`
  ${font_4xl};
  margin: 0;
  font-family: ${font_family_weight_medium};
`

export const VisualizationCaption = styled.figcaption`
  color: ${text_colorTextSecondary};
  ${font_md};
`

export const DataTableWrapper = styled.div`
  overflow: auto;
`

export const DataTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  ${font_md};

  th,
  td {
    padding: ${spacing(3)};
    border-bottom: 1px solid ${base_colorContentBorder};
    text-align: left;
    vertical-align: top;
  }

  th {
    font-family: ${font_family_weight_medium};
    color: ${text_colorTextPrimary};
  }
`

export const TableCaption = styled.caption`
  margin-bottom: ${spacing(3)};
  text-align: left;
  color: ${text_colorTextSecondary};
`
